var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60804 11.7174C1.08092 11.7174 0.643799 11.2802 0.643799 10.7531V5.23767C0.643799 4.71056 1.08092 4.27344 1.60804 4.27344C2.13515 4.27344 2.57227 4.71056 2.57227 5.23767V10.7531C2.57227 11.2931 2.13515 11.7174 1.60804 11.7174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46497 13.5572C4.93785 13.5572 4.50073 13.1201 4.50073 12.593V3.41346C4.50073 2.88634 4.93785 2.44922 5.46497 2.44922C5.99209 2.44922 6.42921 2.88634 6.42921 3.41346V12.593C6.42921 13.133 5.99209 13.5572 5.46497 13.5572Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3219 15.3943C8.79479 15.3943 8.35767 14.9572 8.35767 14.4301V1.57361C8.35767 1.0465 8.79479 0.609375 9.3219 0.609375C9.84902 0.609375 10.2861 1.0465 10.2861 1.57361V14.4301C10.2861 14.9572 9.84902 15.3943 9.3219 15.3943Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1788 13.5572C12.6517 13.5572 12.2146 13.1201 12.2146 12.593V3.41346C12.2146 2.88634 12.6517 2.44922 13.1788 2.44922C13.706 2.44922 14.1431 2.88634 14.1431 3.41346V12.593C14.1431 13.133 13.706 13.5572 13.1788 13.5572Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0358 11.7174C16.5087 11.7174 16.0715 11.2802 16.0715 10.7531V5.23767C16.0715 4.71056 16.5087 4.27344 17.0358 4.27344C17.5629 4.27344 18 4.71056 18 5.23767V10.7531C18 11.2931 17.5629 11.7174 17.0358 11.7174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeak);
export default __webpack_public_path__ + "static/media/speak.c682c3b5705bc5dec7008493e08c8230.svg";
export { ForwardRef as ReactComponent };